import React from "react";
import { Button } from "semantic-ui-react";
import { RutasDidacticasList } from "../../../components/Admin/RutasDidacticasComp";
import { SalasList } from "../../../components/Admin/SalasCmp";
import "./TeacherSalasGrid.scss";

export function TeacherSalasGrid(props) {
  const {
    teacher,
    selectedClass,
    accessToken,
    page,
    setPage,
    reload,
    onReload,
    onNewRoute,
  } = props;

  return (
    <div className="teacher-salas-grid">
      {/* Columna Izquierda (80%) */}
      <div className="teacher-salas-grid__left">
        <SalasList
          classNumber={selectedClass}
          teacher={teacher}
          currentPage={page}
          onPageChange={setPage}
          onTotalPagesChange={() => {}}
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Columna Derecha (20%) */}
      <div className="teacher-salas-grid__right">
        <div className="teacher-salas-grid__top">
          <Button
            className="new-route-btn"
            onClick={onNewRoute}
            
          >
            NUEVO ITINERARIO
          </Button>

          <RutasDidacticasList
            teacherId={teacher?._id}
            teacher={teacher}
            classNumber={selectedClass}
            accessToken={accessToken}
            reload={reload}
          />
        </div>
      </div>
    </div>
  );
} // 